import { InputWithLabel } from '@adotel/components'
import { Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AccountTreeIcon from '@material-ui/icons/AccountTree'
import EmailIcon from '@material-ui/icons/Email'
import PersonIcon from '@material-ui/icons/Person'

import PageHeader from '../../components/PageHeader'
import {
  getEmailFromStorage,
  getNameFromStorage,
  getRoleLabelFromStorage
} from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { useStyles } from './styles/index.styles'

const BasicInfo = () => {
  const theme = useTheme()
  const classes = useStyles()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <>
      <PageHeader title={getTranslate('Basic Info')} />
      <form className={classes.form}>
        {!isSmallScreen && (
          <Typography variant="h2" className={classes.title}>
            {getTranslate('Basic Info')}
          </Typography>
        )}
        <InputWithLabel
          inputSize="small"
          value={getNameFromStorage()}
          label={getTranslate('Full name')}
          placeholder={getTranslate('Full name')}
          fullWidth
          disabled
          endIcon={<PersonIcon />}
        />
        <InputWithLabel
          inputSize="small"
          value={getEmailFromStorage()}
          label={getTranslate('Email')}
          placeholder={getTranslate('Email')}
          fullWidth
          disabled
          endIcon={<EmailIcon />}
        />
        <InputWithLabel
          inputSize="small"
          placeholder={getTranslate('Role')}
          value={getRoleLabelFromStorage()}
          label={getTranslate('Role')}
          fullWidth
          disabled
          endIcon={<AccountTreeIcon />}
        />
      </form>
    </>
  )
}
export default BasicInfo
